var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["../elements/combobox.html"] = require( "../elements/combobox.html" );
dependencies["./table.html"] = require( "./table.html" );
dependencies["./form.html"] = require( "./form.html" );




var shim = require("C:/Users/kaharmanny/source/repos/rentmagic.frontend/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["views/content/quickrent.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("../elements/combobox.html", false, "views/content/quickrent.html", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("combo", t_1);
output += " \r\n";
env.getTemplate("./table.html", false, "views/content/quickrent.html", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
context.setVariable("table", t_4);
output += "\r\n";
env.getTemplate("./form.html", false, "views/content/quickrent.html", false, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
t_7.getExported(function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
context.setVariable("form", t_7);
output += "\r\n\r\n<div class=\"content\">\r\n\t<form class=\"form-view grid row\">\r\n\t\t<input type=\"hidden\" name=\"RentalType\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"formType"), env.opts.autoescape);
output += "\"> \r\n\t\t";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"isNewObject")) {
output += "\r\n\t\t\t<div class=\"col col-xs-12 col-sm-6 col-md-3\">\r\n\t\t\t\t<label class=\"form-field\">\r\n\t\t\t\t\t<div class=\"form-label\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"Customer"), env.opts.autoescape);
output += ": <span class=\"required-indicator\" title=\"\">*</span></div>\r\n\t\t\t\t\t<div class=\"form-input required-field\">\r\n\t\t\t\t\t\t";
output += runtime.suppressValue((lineno = 12, colno = 30, runtime.callWrap(runtime.memberLookup((t_1),"constructCombobox"), "combo[\"constructCombobox\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"Comboboxes")),"CustomerID")])), env.opts.autoescape);
output += "\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</label>\r\n\t\t\t</div>\r\n\t\t\t";
var t_10;
t_10 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"CustomerID") != runtime.contextOrFrameLookup(context, frame, "null");
frame.set("isDisabled", t_10, true);
if(frame.topLevel) {
context.setVariable("isDisabled", t_10);
}
if(frame.topLevel) {
context.addExport("isDisabled", t_10);
}
output += "\r\n\t\t\t<div class=\"col col-xs-12 col-sm-6 col-md-3\">\r\n\t\t\t\t<label class=\"form-field\">\r\n\t\t\t\t\t<div class=\"form-label\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"Contact"), env.opts.autoescape);
output += ":</div>\r\n\t\t\t\t\t<div class=\"form-input required-field\">\r\n\t\t\t\t\t\t";
output += runtime.suppressValue((lineno = 21, colno = 30, runtime.callWrap(runtime.memberLookup((t_1),"constructCombobox"), "combo[\"constructCombobox\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"Comboboxes")),"ContactID")])), env.opts.autoescape);
output += "\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</label>\r\n\t\t\t</div>\r\n\r\n\t\t\t<div class=\"col col-xs-12 col-sm-6 col-md-3\">\r\n\t\t\t\t<label class=\"form-field\">\r\n\t\t\t\t\t<div class=\"form-label\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"Reference"), env.opts.autoescape);
output += ":</div>\r\n\t\t\t\t\t<div class=\"form-input required-field\"><input type=\"text\" name=\"Reference\" class=\"editable-text no-field\" maxlength=\"50\" ";
output += runtime.suppressValue((!runtime.contextOrFrameLookup(context, frame, "isDisabled")?"disabled":""), env.opts.autoescape);
output += "></div>\r\n\t\t\t\t</label>\r\n\t\t\t</div>\r\n\r\n\t\t\t<div class=\"col col-xs-12 col-sm-6 col-md-3\">\r\n\t\t\t\t<label class=\"form-field\">\r\n\t\t\t\t\t<div class=\"form-label\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"StartDate"), env.opts.autoescape);
output += ": <span class=\"required-indicator\" title=\"\">*</span></div>\r\n\t\t\t\t\t<div class=\"form-input required-field date-picker\" data-type=\"Date\">\r\n\t\t\t\t\t\t<input type=\"text\" name=\"DateTimeExpectedStart\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"initialDate"), env.opts.autoescape);
output += "\" class=\"editable-text no-field date\">\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</label>\r\n\t\t\t</div>\r\n\r\n\t\t\t<div class=\"col col-xs-12 col-sm-6 col-md-3\">\r\n\t\t\t\t<label class=\"form-field\">\r\n\t\t\t\t\t<div class=\"form-label\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"EndDate"), env.opts.autoescape);
output += ": ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"EndDateRequired")) {
output += "<span class=\"required-indicator\" title=\"\">*</span>";
;
}
output += "</div>\r\n\t\t\t\t\t<div class=\"form-input date-picker\" data-type=\"Date\">\r\n\t\t\t\t\t\t<input type=\"text\" name=\"DateTimeExpectedEnd\" class=\"editable-text no-field date\" ";
output += runtime.suppressValue((!runtime.contextOrFrameLookup(context, frame, "isDisabled")?"disabled":""), env.opts.autoescape);
output += " ";
output += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "EndDateRequired")?"required":""), env.opts.autoescape);
output += ">\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</label>\r\n\t\t\t</div>\r\n\t\t";
;
}
output += "\r\n\r\n\t\t";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"CanAddNewItems") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"isNewObject")) {
output += "\r\n\t\t\t";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"DisplayCategoryDropdown")) {
output += "\r\n\t\t\t<div class=\"col col-xs-12 col-sm-6 col-md-3\">\r\n\t\t\t\t<label class=\"form-field\">\r\n\t\t\t\t\t<div class=\"form-label\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"Category"), env.opts.autoescape);
output += ":</div>\r\n\t\t\t\t\t<div class=\"form-input required-field\">\r\n\t\t\t\t\t\t";
output += runtime.suppressValue((lineno = 58, colno = 30, runtime.callWrap(runtime.memberLookup((t_1),"constructCombobox"), "combo[\"constructCombobox\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"Comboboxes")),"CategoryID")])), env.opts.autoescape);
output += "\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</label>\r\n\t\t\t</div>\r\n\t\t\t";
;
}
output += "\r\n\r\n\t\t\t<div class=\"col col-xs-12 col-sm-6 col-md-3\">\r\n\t\t\t\t<label class=\"form-field\">\r\n\t\t\t\t\t<div class=\"form-label\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"Scan"), env.opts.autoescape);
output += ":</div>\r\n\t\t\t\t\t<div class=\"form-input required-field combobox-scan\">\r\n\t\t\t\t\t\t";
output += runtime.suppressValue((lineno = 68, colno = 30, runtime.callWrap(runtime.memberLookup((t_1),"constructCombobox"), "combo[\"constructCombobox\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"Comboboxes")),"scannedSerial")])), env.opts.autoescape);
output += "\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</label>\r\n\t\t\t</div>\r\n\r\n\t\t\t<div class=\"col col-xs-12 col-sm-6 col-md-3\" id=\"availabilityModalColumn\">\r\n\t\t\t\t<div id=\"availabilityModal\"></div>\r\n\t\t\t</div>\r\n\t\t";
;
}
output += "\r\n\t</form>\r\n\r\n\t";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"bulkedit")) {
output += "\r\n\t\t<div class=\"table-view unsortable\">\r\n\t\t\t<form class=\"table-container\">\r\n\t\t\t\t<div class=\"table-index sticky-div\">\r\n\t\t\t\t\t<div class=\"table-row\">\r\n\t\t\t\t\t\t<!-- <div class=\"field checkbox selection-box\"><div class=\"ellipsis\"><input type=\"checkbox\" title=\"Select all\"></div></div> -->\r\n\t\t\t\t\t\t<div class=\"table-cell delete-row material-icons\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"Delete"), env.opts.autoescape);
output += "\">\r\n\t\t\t\t\t\t\t<div class=\"ellipsis\">&#xe5cd;</div>\r\n\t\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t\t";
frame = frame.push();
var t_13 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"Columns");
if(t_13) {var t_12 = t_13.length;
for(var t_11=0; t_11 < t_13.length; t_11++) {
var t_14 = t_13[t_11];
frame.set("col", t_14);
frame.set("loop.index", t_11 + 1);
frame.set("loop.index0", t_11);
frame.set("loop.revindex", t_12 - t_11);
frame.set("loop.revindex0", t_12 - t_11 - 1);
frame.set("loop.first", t_11 === 0);
frame.set("loop.last", t_11 === t_12 - 1);
frame.set("loop.length", t_12);
output += "\r\n\t\t\t\t\t\t\t";
var t_15;
t_15 = "table-cell";
frame.set("classes", t_15, true);
if(frame.topLevel) {
context.setVariable("classes", t_15);
}
if(frame.topLevel) {
context.addExport("classes", t_15);
}
output += "\r\n\r\n\t\t\t\t\t\t\t";
if(runtime.memberLookup((t_14),"Type") == "Money") {
output += "\r\n\t\t\t\t\t\t\t\t";
var t_16;
t_16 = runtime.contextOrFrameLookup(context, frame, "classes") + " number";
frame.set("classes", t_16, true);
if(frame.topLevel) {
context.setVariable("classes", t_16);
}
if(frame.topLevel) {
context.addExport("classes", t_16);
}
output += "\r\n\t\t\t\t\t\t\t";
;
}
output += "\r\n\r\n\t\t\t\t\t\t\t";
if(runtime.memberLookup((t_14),"Type") == "Decimal") {
output += "\r\n\t\t\t\t\t\t\t\t";
var t_17;
t_17 = runtime.contextOrFrameLookup(context, frame, "classes") + " number";
frame.set("classes", t_17, true);
if(frame.topLevel) {
context.setVariable("classes", t_17);
}
if(frame.topLevel) {
context.addExport("classes", t_17);
}
output += "\r\n\t\t\t\t\t\t\t";
;
}
output += "\r\n\r\n\t\t\t\t\t\t\t";
if(runtime.memberLookup((t_14),"Type") == "Int") {
output += "\r\n\t\t\t\t\t\t\t\t";
var t_18;
t_18 = runtime.contextOrFrameLookup(context, frame, "classes") + " number";
frame.set("classes", t_18, true);
if(frame.topLevel) {
context.setVariable("classes", t_18);
}
if(frame.topLevel) {
context.addExport("classes", t_18);
}
output += "\r\n\t\t\t\t\t\t\t";
;
}
output += "\r\n\r\n\t\t\t\t\t\t\t<div class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "classes"), env.opts.autoescape);
output += "\" data-column=\"";
output += runtime.suppressValue(runtime.memberLookup((t_14),"Name"), env.opts.autoescape);
output += "\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((t_14),"Title"), env.opts.autoescape);
output += "\">\r\n\t\t\t\t\t\t\t\t<div class=\"ellipsis\">\r\n\t\t\t\t\t\t\t\t\t";
output += runtime.suppressValue(runtime.memberLookup((t_14),"Title"), env.opts.autoescape);
output += "\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<!-- <div class=\"field\" title=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "i"), env.opts.autoescape);
output += "\"><div class=\"ellipsis\"><input type=\"checkbox\"></div></div> -->";
;
}
}
frame = frame.pop();
output += "\r\n\r\n\t\t\t\t\t\t<div class=\"table-cell dropdown-info\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"UncollapseAll"), env.opts.autoescape);
output += "\">\r\n\t\t\t\t\t\t\t<div class=\"ellipsis\" data-show-all-lower-fields>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"UncollapseAll"), env.opts.autoescape);
output += "</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\r\n\t\t\t\t<div class=\"table-body bulkedit\">\r\n\t\t\t\t\t<div class=\"table-rows\">\r\n\t\t\t\t\t\t<div class=\"table-row-group\">\r\n\t\t\t\t\t\t\t<div class=\"table-row new-row\">\r\n\t\t\t\t\t\t\t\t<!-- <div class=\"field checkbox selection-box\"><input type=\"checkbox\" data-commit-checkbox=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
output += "\" title=\"Select\"></div> -->\r\n\t\t\t\t\t\t\t\t<div class=\"table-cell delete-row material-icons\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"Delete"), env.opts.autoescape);
output += "\">\r\n\t\t\t\t\t\t\t\t\t<div class=\"ellipsis\">&#xe5cd;</div>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t";
frame = frame.push();
var t_21 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"Columns");
if(t_21) {var t_20 = t_21.length;
for(var t_19=0; t_19 < t_21.length; t_19++) {
var t_22 = t_21[t_19];
frame.set("col", t_22);
frame.set("loop.index", t_19 + 1);
frame.set("loop.index0", t_19);
frame.set("loop.revindex", t_20 - t_19);
frame.set("loop.revindex0", t_20 - t_19 - 1);
frame.set("loop.first", t_19 === 0);
frame.set("loop.last", t_19 === t_20 - 1);
frame.set("loop.length", t_20);
output += runtime.suppressValue(env.getFilter("dump").call(context, runtime.memberLookup((t_22),"ItemID")), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(env.getFilter("dump").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "cell")),"ItemID")), env.opts.autoescape);
output += "\r\n\t\t\t\t\t\t\t\t\t<!--{ % if col.Name === \"SerialID\" % }\r\n\t\t\t\t\t\t\t\t\t\t";
output += runtime.suppressValue((lineno = 129, colno = 30, runtime.callWrap(runtime.memberLookup((t_4),"setColumnCell"), "table[\"setColumnCell\"]", context, [t_22,"",runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"),"",runtime.contextOrFrameLookup(context, frame, "window"),runtime.contextOrFrameLookup(context, frame, "null"),runtime.contextOrFrameLookup(context, frame, "null"),runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Data")),"Metadata")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index"))])), env.opts.autoescape);
output += "\r\n\t\t\t\t\t\t\t\t\t{ % elif col.Combobox % }-->\r\n\t\t\t\t\t\t\t\t\t";
if(runtime.memberLookup((t_22),"Combobox")) {
output += "\r\n\t\t\t\t\t\t\t\t\t\t";
output += runtime.suppressValue((lineno = 132, colno = 45, runtime.callWrap(runtime.memberLookup((t_1),"constructTableRecordCombobox"), "combo[\"constructTableRecordCombobox\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session"),runtime.memberLookup((t_22),"Combobox"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0")])), env.opts.autoescape);
output += "\r\n\t\t\t\t\t\t\t\t\t";
;
}
else {
output += "\r\n\t\t\t\t\t\t\t\t\t\t";
output += runtime.suppressValue((lineno = 134, colno = 30, runtime.callWrap(runtime.memberLookup((t_4),"setColumnCell"), "table[\"setColumnCell\"]", context, [t_22,"",runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"),"",runtime.contextOrFrameLookup(context, frame, "window"),runtime.contextOrFrameLookup(context, frame, "null"),runtime.contextOrFrameLookup(context, frame, "null"),runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Data")),"Metadata")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index"))])), env.opts.autoescape);
output += " \r\n\t\t\t\t\t\t\t\t\t";
;
}
output += "\r\n\t\t\t\t\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t\t\t\t\t<div class=\"table-cell dropdown-info material-icons\" data-toggle-lower-field>&#xe313;</div>\r\n\t\t\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t\t\t<td class=\"lower-field hide\" colspan=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"Columns")),"length") + 2, env.opts.autoescape);
output += "\">\r\n\t\t\t\t\t\t\t\t\t<form class=\"form-view grid row\">\r\n\t\t\t\t\t\t\t\t\t\t";
frame = frame.push();
var t_25 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"ColumnsExtra");
if(t_25) {var t_24 = t_25.length;
for(var t_23=0; t_23 < t_25.length; t_23++) {
var t_26 = t_25[t_23];
frame.set("col", t_26);
frame.set("loop.index", t_23 + 1);
frame.set("loop.index0", t_23);
frame.set("loop.revindex", t_24 - t_23);
frame.set("loop.revindex0", t_24 - t_23 - 1);
frame.set("loop.first", t_23 === 0);
frame.set("loop.last", t_23 === t_24 - 1);
frame.set("loop.length", t_24);
output += "<div class=\"col col-xs-12 col-sm-6 col-md-20\">\r\n\t\t\t\t\t\t\t\t\t\t\t<label class=\"form-field\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"form-label\">";
output += runtime.suppressValue(runtime.memberLookup((t_26),"Title"), env.opts.autoescape);
output += "\r\n\t\t\t\t\t\t\t\t\t\t\t\t";
if(runtime.memberLookup((t_26),"IsRequired")) {
output += "\r\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"required-indicator\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "session")),"translations")),"RequiredField"), env.opts.autoescape);
output += "\">*</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t";
;
}
output += "\r\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"form-input required-field ";
output += runtime.suppressValue((runtime.memberLookup((t_26),"Type") == "Money"?"money":""), env.opts.autoescape);
output += "\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t";
output += runtime.suppressValue((lineno = 152, colno = 35, runtime.callWrap(runtime.memberLookup((t_7),"createInputField"), "form[\"createInputField\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session"),t_26,runtime.memberLookup((t_26),"Type"),runtime.contextOrFrameLookup(context, frame, "null"),runtime.memberLookup((t_26),"Initial"),runtime.contextOrFrameLookup(context, frame, "null"),runtime.contextOrFrameLookup(context, frame, "null"),runtime.contextOrFrameLookup(context, frame, "window")])), env.opts.autoescape);
output += "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t";
output += "\r\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t\t\t\t\t\t</form>\r\n\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</form>\r\n\r\n\t\t\t<div class=\"table-footer clearfix sticky-div stick-to-bottom\">\r\n\t\t\t\t<div class=\"fake-button button button-menu no-hover no-action\">\r\n\t\t\t\t\t<span data-select-count title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"SelectCount"), env.opts.autoescape);
output += "\">0</span>\r\n\t\t\t\t</div>\r\n\r\n\t\t\t\t";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"product") == "RentMagic") {
output += "\r\n\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t<div class=\"fake-button button button-menu no-hover no-action\">\r\n\t\t\t\t\t\t";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"TotalPriceExcVAT"), env.opts.autoescape);
output += ": <span data-total-price>0.00</span>\r\n\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t<div class=\"fake-button button button-menu no-hover no-action\">\r\n\t\t\t\t\t\t";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"TotalVAT"), env.opts.autoescape);
output += ": <span data-total-btw>0.00</span>\r\n\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t<div class=\"fake-button button button-menu no-hover no-action\">\r\n\t\t\t\t\t\t";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"TotalPriceIncVAT"), env.opts.autoescape);
output += ": <span data-total-btw-price>0.00</span>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t";
;
}
output += "\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t";
;
}
output += "\r\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["views/content/quickrent.html"] , dependencies)